<template>
	<div>
		<Form ref="formInline" inline style="text-align: center;margin-top: 10px;color: black;">
			<RadioGroup @on-change="radioChange" size='large' v-model="Methodtype">
				<Radio :label="$t('MenuManagement.AddMenu')">
					<Icon type="ios-add-circle" />
					<span>{{ $t('MenuManagement.AddMenu') }}</span>
				</Radio>
				<Radio :label="$t('MenuManagement.EditMenu')">
					<Icon type="ios-add-circle" />
					<span>{{ $t('MenuManagement.EditMenu') }}</span>
				</Radio>
				<Radio :label="$t('MenuManagement.DeleteMenu')">
					<Icon type="md-trash" />
					<span>{{ $t('MenuManagement.DeleteMenu') }}</span>
				</Radio>
			</RadioGroup>
			<Button type="primary" @click="assignMenuWidgets" :disabled="selectedMenuId == 0">{{ $t('MenuManagement.ControlAllocation') }}</Button>
		</Form>
		<div style="float: left; overflow-y: auto;">
			<Tree style="text-align: left;" @on-select-change="getSelect" :data="Menus" ref="tree"></Tree>
		</div>
		<div>
			<Card style="float: right;margin-right: 30%;margin-top: 10%;width: 40%;">
				<p style="color: #000000;" slot="title">{{ $t('Common.Actions')}}:{{Methodtype}}-------->{{selectTree}}</p>
				<p style="color: #000000;margin-bottom: 0.15625rem;">{{ $t('MenuManagement.ClickLeftMenuAndEdit')}}</p>
				<Form :rules="ruleInline" v-if="Methodtype==$t('MenuManagement.AddMenu')||Methodtype==$t('MenuManagement.EditMenu')||Methodtype==$t('MenuManagement.EditMenu')"
					label-position="right" ref="menuForm" :model="menuInfo" :label-width="90">
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem :label="$t('MenuManagement.MenuName')" prop="title">
							<Input :disabled="canInput" v-model="menuInfo.title" :placeholder="$t('MenuManagement.MenuName')"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem :label="$t('MenuManagement.MenuDesc')" prop="Desc">
							<Input :disabled="canInput" v-model="menuInfo.Desc" :placeholder="$t('MenuManagement.MenuDesc')"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem :label="$t('MenuManagement.MenuUrl')" prop="Url">
							<Input :disabled="canInput" v-model="menuInfo.Url" :placeholder="$t('MenuManagement.MenuUrl')"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem :label="$t('MenuManagement.MenuAction')" prop="AspAction">
							<Input :disabled="canInput" v-model="menuInfo.AspAction" :placeholder="$t('MenuManagement.MenuAction')"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=12>
						<FormItem :label="$t('MenuManagement.MenuAction')" prop="AspController">
							<Input :disabled="canInput" v-model="menuInfo.AspController"
								:placeholder="$t('MenuManagement.MenuAction')"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem :label="$t('MenuManagement.SequenceNumber')" prop="Sortorder">
							<Input :disabled="canInput" v-model="menuInfo.Sortorder" :placeholder="$t('MenuManagement.SequenceNumber')"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem :label="$t('MenuManagement.Icon')" prop="Icon">
							<Input :disabled="canInput" v-model="menuInfo.Icon" :placeholder="$t('MenuManagement.Icon')"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem :label="$t('MenuManagement.MenuName')" prop="DisplayName">
							<Input :disabled="canInput" v-model="menuInfo.DisplayName" :placeholder="$t('MenuManagement.MenuName')"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem :label="$t('MenuManagement.ParentMenu')" prop="TopName">
							<Input :disabled="true" v-model="menuInfo.topName" :placeholder="$t('MenuManagement.ParentMenu')"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem :label="$t('MenuManagement.ParentFlag')" prop="ParentId">
							<Input :disabled="true" v-model="menuInfo.ParentId" :placeholder="$t('MenuManagement.ParentMenu')"></Input>
						</FormItem>
						</Col>
					</Row>
					<div v-if="Methodtype==$t('MenuManagement.AddMenu')">
						<Button type="success" long size="large" @click="modalOk('add')">{{ $t('Common.Add') }}</Button>
					</div>
					<div v-if="Methodtype==$t('MenuManagement.EditMenu')">
						<Button type="warning" long size="large" @click="modalOk('up')">{{$t('MenuManagement.EditMenu')}}</Button>
					</div>
					<div v-if="Methodtype==$t('MenuManagement.EditMenu')">
						<Button type="error" long size="large" @click="modalOk('del')">{{ $t('Common.Add') }}</Button>
					</div>
				</Form>
			</Card>
		</div>
		<Modal v-model="modalAssign" :title="$t('MenuManagement.ControlAllocation')+'[' + selectTree + ']'" :loading="true" @on-ok="asyncOK">
			<Transfer :data="dataWidgets" :target-keys="targetWidgets" :render-format="renderWidgets"
				@on-change="handleChangeWidgets" :titles="[$t('MenuManagement.Unallocated'), $t('MenuManagement.Allocated')]">
			</Transfer>
		</Modal>
	</div>
</template>

<script>
	import webapi from '../../../webapi';
	export default {
		data() {
			return {
				BreadcrumbList: [this.$t('Top.privilegeManage'), '>>', this.$t('menuManage')],
				Menus: [],
				canInput: false,
				menuInfo: {
					Id: 0,
					title: '',
					Desc: '',
					Url: '',
					AspAction: '',
					AspController: '',
					Sortorder: 0,
					Icon: '',
					DisplayName: '',
					topName: '',
					ParentId: '',
					children: '',
				},
				dataWidgets: [],
				targetWidgets: [],
				modalAssign: false,
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					title: [{
						required: true,
						message: 'title',
						trigger: 'blur'
					}],
					DisplayName: [{
						required: true,
						message: 'DisplayName',
						trigger: 'blur'
					}],
				},
				Methodtype: this.$t('MenuManagement.AddMenu'),
				selectTree: '',
				selectedMenuId: 0,
			}
		},
		mounted() {
			this.getMenus();

			const _this = this;
			this.$axios.post(webapi.base_api_url + '/System/GetSysWidgets', {
				pageSize: 10000
			}).then(res => {
				if (res.status == 200 && res.data.Code == 0) {
					_this.dataWidgets = res.data.Data.List.map(obj => {
						return {
							key: obj.Id,
							label: obj.Display,
							description: obj.Desc
						}
					});
				}
			});

		},
		methods: {
			getMenus: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + "/System/GetSysMenus", {}).then(res => {
					if (res.data.Code == 0) {
						// this.dealMenu(res.data.Data.List)
	                    var menuList = this.replaceFieldInTree(res.data.Data.List);
						_this.Menus = [{
							id: 0,
							title: this.$t('MenuManagement.SystemMenu'),
							children: menuList,
							expand: true,
						}];
					}
				})
			},
			 replaceFieldInTree(tree, childrenKey = 'children') {
  return tree.map(node => {

    const newNode = { ...node };

    // 优先使用菜单专用翻译键（如 SplitRuleMenu），否则使用默认键
    const menuKey = node.name + 'Menu';
    if (this.$te(menuKey)) {
      newNode.title = this.$t(menuKey);
    } else {
      newNode.title = this.$t(node.name);
    }


    if (newNode[childrenKey] && newNode[childrenKey].length > 0) {
      newNode[childrenKey] = this.replaceFieldInTree(newNode[childrenKey], childrenKey);
    }

    return newNode;
  });
},
			
			radioChange: function() {
				const _this = this
				let a = _this.Methodtype
				let select = _this.$refs.tree.getSelectedNodes()
				// if (select.length != 0) {
				// 	select[0].selected = false
				// }
				_this.menuInfo = {
					Id: 0,
					title: '',
					Desc: '',
					Url: '',
					AspAction: '',
					AspController: '',
					Sortorder: 0,
					Icon: '',
					DisplayName: '',
					TopName: '',
					ParentId: '',
					children: '',
				}
				// _this.selectTree = ''
				switch (a) {
					case this.$t('MenuManagement.EditMenu'):
						_this.canInput = false
						break;
					case this.$t('MenuManagement.DeleteMenu'):
						_this.canInput = true
						break;
					case this.$t('MenuManagement.AddMenu'):
						_this.canInput = false
						break;
					default:
						break;
				}
			},
			getSelect: function(arr, item) {
				const _this = this
				if (item.children.length == 0) {
					_this.selectedMenuId = item.Id;
				} else {
					_this.selectedMenuId = 0;
				}

				if (arr.length == 0) {
					_this.$refs.menuForm.resetFields()
				} else {
					let a = _this.Methodtype
					switch (a) {
						case this.$t('MenuManagement.EditMenu'):
							_this.menuInfo = Object.assign({}, item)
							_this.selectTree = item.DisplayName
							_this.canInput = false
							break;
						case this.$t('MenuManagement.DeleteMenu'):
							_this.selectTree = item.DisplayName
							_this.menuInfo = Object.assign({}, item)
							_this.canInput = true
							break;
						case this.$t('MenuManagement.AddMenu'):
							_this.selectTree = this.$t('MenuManagement.ParentMenu')+':' + item.DisplayName
							//_this.menuInfo=Object.assign({},item)
							_this.menuInfo.ParentId = item.Id
							_this.menuInfo.topName = item.title
							_this.canInput = false
							break;
						default:
							this.$Message.error(this.$t('MenuManagement.NeedToSelectMenu'))
							item.selected = false
							break;
					}
				}
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'distribute':
						this.$Message.error("Empty")
						break;
					case 'add':
						this.AddSysMenu()
						break;
					case 'del':
						this.$Message.error("Empty")
						break;
					case 'up':
						this.AddSysMenu()
						break;
					default:
						break;
				}
			},
			AddSysMenu: function(type) {
				const _this = this;
				_this.$refs.menuForm.validate((valid) => {
					console.log("Menu" + type + "----" + valid)
					if (valid) {
						let parms = _this.menuInfo
						_this.$axios.post(webapi.base_api_url + "/System/AddSysMenu", parms, {}).then(res => {
							console.log("Add Menu")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success(this.$t('Common.AddSuccess'));
								_this.getMenus();
								_this.radioChange()
								_this.modalOk("cancle")
							} else {
								this.$Message.error(res.data.Msg + "---" + res.data.Data);
							}
						})
					}
				})
			},
			assignMenuWidgets: function() {
				const _this = this;
				// this.$axios.post(webapi.base_api_url + '/System/GetSysWidgets', {
				// 	pageSize: 10000
				// }).then(res => {
				// 	if (res.status == 200 && res.data.Code == 0) {
				// 		_this.dataWidgets = res.data.Data.List;
				// 	}
				// });
				this.$axios.post(webapi.base_api_url + '/System/GetWidgetsByMenuId', {
					menuId: _this.selectedMenuId
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.targetWidgets = res.data.Data.List.map(obj => obj.Id);
					}
				});
				// this.$Message.success(this.selectedMenuId + '');
				this.modalAssign = true;
			},
			renderWidgets: function(item) {
				return item.label;
			},
			handleChangeWidgets: function(newTargetKeys, direction, moveKeys) {
				this.targetWidgets = newTargetKeys;
			},
			asyncOK: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/System/AssignMenuWidgets', {
					menuId: this.selectedMenuId,
					widgets: this.targetWidgets
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.modalAssign = false;
					} else {
						_this.$Message.error(this.$t('Common.OperationFailed'));
					}
				});
			}
		}
	}
</script>

<style>
	.ivu-tree-title-selected,
	.ivu-tree-title-selected:hover {
		background-color: #00FF00;
		color: white;
		font-weight: bold;
	}
</style>
